<template>
  <div>
    <nav style="min-height: 60px;" class="navbar" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
     <a @click="gopath('/profile')" class="navbar-item" style="font-size: 23px; font-weight: bold; color: black !important;">
        Mentor profile
      </a>
    <a @click="showNav = !showNav" :class="{ 'is-active': showNav }"  role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div id="navbarBasicExample" class="navbar-menu">
    <div class="navbar-start">
    </div>
    <div class="navbar-end">
      <div v-if="!islogin.userId" class="navbar-item">
        <div  class="buttons">
          <a @click="gopath('/signin')" class="button is-primary">
            <span>SIGN IN</span>
          </a>
          <a @click="gopath('/signup/company')" class="button is-light">
             <span>SIGN UP</span>
          </a>
        </div>
      </div>
        <div v-if="islogin.userId" class="navbar-item">
          <div  class="buttons">
            <a @click="openmodalprofile" class="button is-primary">
              <span>PROFILE</span>
            </a>
            <a @click="signout" class="button is-primary">
              <span>SIGN OUT</span>
            </a>
          </div>
      </div>
    </div>
  </div>
  <div class="navbar-menu" v-if="showNav" :class="{ 'is-active': showNav }">
        <div v-if="!islogin.userId" class="navbar-end">
          <a @click="gopath('/signin')" class="button is-primary">
            <span>SIGN IN</span>
          </a>
          <a @click="gopath('/signup/company')" class="button is-light">
             <span>SIGN UP</span>
          </a>
        </div>
         <div v-if="islogin.userId" class="navbar-item">
            <!-- <div  class="buttons">
          
          </div> -->
          <div  class="buttons">
              <a @click="openmodalprofile" class="button is-primary">
              <span>PROFILE</span>
            </a>
            <a @click="signout" class="button is-primary">
              <span>SIGN OUT</span>
            </a>
          </div>
      </div>
    </div>
</nav>
 <b-modal class="modalmentor" :active.sync="isComponentModalActive" has-modal-card>
            <form action="">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                          <button v-if="!ispassword" class="button edit" type="button" @click="isedit = !isedit">Edit</button>

                          <button v-if="ispassword" class="button edit" type="button" @click="ispassword = !ispassword">Back</button>
                            <p  class="modal-card-title">
                          <span v-if="!ispassword"> Profile </span>
                            <span v-if="ispassword"> Change Password</span>
                          </p>
                    <button class="button close" type="button" @click="isComponentModalActive = false"><i class="fas fa-times"></i></button>
                
                    </header>
                        <div v-if="!ispassword" id="preview"  >
                           <label for="uploadfile">
                             
                            <img v-if="file.name && url == null" class="haveimg" :src="`http://206.189.154.242:3098/images/profilePic/${file.name}`" />
                            <img v-if="url" class="haveimg" :src="url" />
                            <div v-if="!file.name && !url" class="noimg">
                                <div class="font">170 x 170</div>
                                <div class="circle"></div>
                            </div>
                         </label>
                    </div>
                       <input v-if="!ispassword && !isedit" style="display:none"  type="file" id="uploadfile" name="uploadfile" @change="uploadFile($event)">
                        <div v-if="!ispassword && !isedit" style="text-align:center;background:White;">
                            <b-icon pack="fas"  icon="file-upload"  custom-class="fa-cloud-upload-alt mg-x-1 has-text-grey-dark"
                                    ></b-icon>
                        <label  for="uploadfile">{{file.name ? file.name : 'No file chosen'}}</label>
                    </div>
                    <section v-show="!ispassword"  class="modal-card-body">
                         <b-field  label="Name">
                           <!-- {{ isedit }} -->
                            <b-input
                                :class="{activeinput:!isedit}"
                                :readonly="isedit"   
                                v-model="editprofile.name"
                                placeholder="Your Name"
                                required>
                            </b-input>
                        </b-field>
                        <b-field  label="Surname">
                            <b-input
                                :class="{activeinput:!isedit}"
                                :readonly="isedit"
                                v-model="editprofile.surname"
                                placeholder="Your Surname"
                                required>
                            </b-input>
                        </b-field>
                        <b-field  label="Email">
                            <b-input
                                readonly
                                type="email"
                                v-model="editprofile.email"
                                placeholder="Your email"
                                >
                            </b-input>
                        </b-field>
                    </section>

         <section v-show="ispassword"  class="modal-card-body">
                        <b-field class="password" v-if="ispassword" label="Oldpassword">
                            <b-input
                            type="password"
                                v-model="pass.oldpassword"
                                placeholder="Your oldpassword"
                                >
                            </b-input>
                        </b-field>
                        <b-field class="password" v-if="ispassword" label="NewPassword">
                            <b-input
                                type="password"
                                v-model="pass.password"
                                placeholder="Your Password"
                                >
                            </b-input>
                        </b-field>
                        <b-field v-if="ispassword" label="RePassword">
                            <b-input
                               type="password"
                               v-model="pass.repassword"
                                placeholder="Your Password"
                                >
                            </b-input>
                        </b-field>
         </section>
                        
                        <div v-if="!ispassword" class="flexcenter">
                        <b-button @click="ispassword = !ispassword" type="is-info" class="Filters" id="Filters" outlined>
                          <span class="white" >Change Password </span>
                        </b-button>
                        </div>

                 
                    <footer class="modal-card-foot">
                        <button v-if="!ispassword" class="button" @click="editprofile_f" type="button"  >Submit</button>
                          <button v-if="ispassword"  class="button" type="button" @click="changepassword">Change Password</button>
                        <!-- <button class="button is-success"></button> -->
                    </footer>
                </div>
            </form>
        </b-modal>
  </div>
</template>

<script>
import {HTTP,HTTPMentor} from "@/axios.js";
export default {
  data(){
    return{
      showNav: false,
      isComponentModalActive:false,
      file:{
        name:''
      },
      url:null,
      ispassword:false,
      isedit:true,
      pass:{
        oldpassword:'',
        password:'',
        repassword:'',
      },
      editprofile:{
        name:'',
        surname:'',
        profilePic:'',
        email:'',
      }
    }
  },
  computed:{
            idlogin(){
            return this.$store.state.idlogin
           },
            islogin(){
            return this.$store.state.islogin
           },
  },
  created(){
    console.log(this.islogin)
    this.editprofile.name = this.islogin.detailUser[0].name
    this.editprofile.surname = this.islogin.detailUser[0].surname
    this.editprofile.profilePic = this.islogin.detailUser[0].profilePic
    this.editprofile.email = this.islogin.detailUser[0].email
  
    this.file.name = this.islogin.detailUser[0].profilePic
  },
  methods:{
    changepassword(){
      if(!this.pass.oldpassword || !this.pass.password || !this.pass.repassword){
        this.$dialog.alert('<p class="has-text-centered is-size-5">Please type in all required fields</p>');
      }

      if(this.pass.repassword != this.pass.password ){
          this.$dialog.alert('<p class="has-text-centered is-size-5">Your Password and Re-password <br> do not match</p>');
      }

          let dataf ={
            userId:this.islogin.userId,
            passOld:this.pass.oldpassword,
            newPass:this.pass.password
          }
           console.log('dsaldsakdnmkdsandkasndksank',JSON.stringify(dataf))
              HTTPMentor.post(`update/password`,dataf).then(res => {
                if (res.data.success) {
                    this.$dialog.alert('<p class="has-text-centered is-size-5">Edit Password Success</p>');
                    this.pass = {}
                }else{
                    this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
                }
                 }).catch(e => {
                console.log("upload/file/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Password not match</p>');
                })


    },
    editprofile_f(){
      var data ={
        userId:this.islogin.userId,
        name:this.editprofile.name,
        surname:this.editprofile.surname,
        profilePic:this.editprofile.profilePic,
      }
      // console.log(JSON.stringify(data))` ${this.token}`
           HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.islogin.token}`
          if(this.editprofile.name && this.editprofile.surname && this.editprofile.profilePic){

             HTTPMentor.post(`update/account`,data).then(res => {
                if (res.data.success) {
                    this.$dialog.alert('<p class="has-text-centered is-size-5">Edit Profile Success</p>');
                }else{
                    this.$dialog.alert('<p class="has-text-centered is-size-5">Edit Profile Error</p>');
                }
                 let updatedata ={
                    name:this.editprofile.name,
                    surname:this.editprofile.surname,
                    profilePic:this.editprofile.profilePic,
                }
                this.$store.commit('changenamesurnamepic',updatedata)
            })
            .catch(e => {
                console.log("upload/file/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Edit Profile not work</p>');
            })
          }else{
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please type in all required fields</p>');
          }
    },
    uploadFile(event){
            console.log('eventeventeventevent',event.target.files[0])
            const formData = new FormData();
            formData.append("file", event.target.files[0]);
            
            // HTTPMentor.defaults.headers.common.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IiIsIl9pZCI6IjVjY2JmMGI4OTRiY2I1MjQ3MjI3M2FiYyIsImFsZyI6IkhTMjU2IiwiaWF0IjoxNTU3NzQwMTAyfQ.NGduJrRb52x5iBuh_r3_Ka6Qdx9w4U4dZQB5KNxWnJY`; 
             HTTPMentor.post(`upload/profilePic/`,formData)
            .then(res => {
                console.log("upload/file", res);  
                if (res.data.success) {
                    this.editprofile.profilePic =  res.data.obj
                    this.url = URL.createObjectURL(event.target.files[0]);
                    this.file.name = event.target.files[0].name
                    // this.$dialog.alert('<p class="has-text-centered is-size-5">Upload Success</p>');
                }else{
                    this.$dialog.alert('<p class="has-text-centered is-size-5">Upload Error</p>');
                }
            })
            .catch(e => {
                console.log("upload/file/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Upload not work</p>');
            })
        },
    openmodalprofile(){
      this.isComponentModalActive = true
    },
    signout(){
            // localStorage.clear();
            this.$store.commit('clearlogin',true)
            this.$router.push('/signin')
        },
     gopath(val){
             this.$router.push(val)
        },
  }
}
</script>
<style scoped>
.activeinput input{
 box-shadow: 0 0 0 1px #0FB9F4
}
.flexcenter{
  display: flex;
  justify-content: center;
      background: white;
    padding-bottom: 25px;
}
#Filters.Filters{
  right: 1px;
  display:block;float:right;padding: 0 2rem;border:none;background: linear-gradient(180deg, #0D6ACA 0%, #0FB9F4 100%); border-radius: 40px;
}
#Filters.activefilter{
  border: 1px solid #0D6ACA !important;
  background: transparent !important;
}

#Filters.activefilter span,#Filters.activefilter i{
  color: #0D6ACA !important;
}

#Filters .white{
  color:white;
}
#Filters:hover{
  box-shadow: 0 0 0 1px #0D6ACA !important;
  /* border: 1px solid #0D6ACA !important; */
    background: transparent !important;
}

#Filters:hover .white,#Filters:hover i{
  color:#0D6ACA;
}
.modal-card-body .field{
  min-height: 66px
}
.modal-card-head{
  position:relative
}
.modal-card-head .close{
 position: absolute;
 right: 10px;
}
.modal-card-head .edit{
 position: absolute;
 left: 10px;
}


.field{
  position: relative;
}
.help.is-danger{
  color: #ff3860;
  top: 0 !important
}

/* preview */
label{
    cursor: pointer;
}
#preview{
  padding-top: 10px;
  background: white;
  display: flex; justify-content: center;
}
#preview .haveimg{
    border-radius:50%;
}
#preview .noimg{
    position:relative;
}
#preview .noimg .font{
    position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)
}
#preview .noimg .circle{
    border-radius: 50%; height: 170px !important; width: 170px !important; background: rgba(0,0,0,0.25); margin: 0 auto;
}
/* preview */
.modal .animation-content{
  width: 500px !important
}
.button{
    color: #FD7900 !important;
    background-color:transparent !important;
}

</style>